import { render, staticRenderFns } from "./market-table.vue?vue&type=template&id=9fd2f458&scoped=true&"
import script from "./market-table.vue?vue&type=script&lang=js&"
export * from "./market-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fd2f458",
  null
  
)

export default component.exports